import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subscription} from "rxjs/internal/Subscription";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {toastrService} from "../../../../services/ux/toastr.service";
import {WalletService} from "../../../../services/wallet.service";
import {ActivatedRoute} from "@angular/router";
import {ModalPaymentService} from "../../../../services/ux/modal-payment.service";
import {ModalReconfirmNumberService} from "../../../../services/ux/modal-reconfirm-number.service";
import {LocalStorage} from "../../../../services/local-storage";
import {HttpErrorResponse} from "@angular/common/http";
import {finalize} from "rxjs/operators";
import {TransactionStatusEmitter} from "../../../../models/Payment/Emitters/transaction-status-emitter";
import {OneHttpClientService} from "../../../../data/one-http-client.service";
import { TranslateService } from "@ngx-translate/core"; 

@Component({
    selector: "app-one",
    templateUrl: "./one.component.html",
    styleUrls: ["./one.component.css"]
})
export class OneComponent implements OnInit, OnDestroy {

    // region Subscriptions
    subscription: Subscription;
    ccSubscription: Subscription;
    finishTransactionSubscription: Subscription;
    //#endregion

    @ViewChild("containerDiv") divToScroll: ElementRef<HTMLDivElement>;

    readonly amountsAllowed: number[] = [
        100, 200, 300, 500, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 2000, 2500
    ];

    // region Forms
    // region searchOffers Form
    searchForm = new FormGroup({
        mobileNumber: new FormControl("", [Validators.required, Validators.minLength(10)])
    });
    // endregion

    // region PayForm
    paymentForm = new FormGroup({
        amount: new FormControl("0", Validators.required),
        shouldSearchForOffers: new FormControl(true),
    });
    // endregion
    // endregion
    isLoading = false;

    // endregion

    // region Screens

    // * Insert number
    screenOne = true;
    // * After number is confirmed
    screenTwo: boolean = null;
    // * Show list of offers if user checked the checkbox
    screenThree: boolean = null;

    // endregion

    komisionCC = 0;

    constructor(
        private oneHttpClient: OneHttpClientService,
        private toastr: toastrService,
        private walletService: WalletService,
        private route: ActivatedRoute,
        private modalService: ModalPaymentService,
        private confirmNumberModalService: ModalReconfirmNumberService,
        private ls: LocalStorage,
        private translateService: TranslateService
    ) {
        this.subscription = walletService.$walletReadyEmitter.subscribe(
            (isReady: boolean) => {
                if (isReady) {
                    this.processOneTransaction();
                }
            }
        );

        this.ccSubscription = walletService.$creditCardReadyEmitter.subscribe(
            (ccSelected: boolean) => {
                if (ccSelected) {
                    this.processOneTransaction();
                }
            }
        );

        this.finishTransactionSubscription = this.walletService.$transactionFinish.subscribe(
            (isSuccess) => {
                // * If transaction is success
                if (isSuccess) {
                    // * If user checked the activation of offers
                    if (this.paymentForm.value.shouldSearchForOffers) {
                        this.switchScreen(3);
                        this.modalService.close();
                    } else {
                        this.switchScreen(1);
                    }
                } else {
                    this.switchScreen(1);
                }
            }
        );
    }

    ngOnInit() {
        this.route.params.subscribe((params: any) => {
            if (params.mobileNumber) {
                this.searchForm.controls["mobileNumber"].setValue(params.mobileNumber);
            }
        });
    }

    onValidate() {
        if (!this.searchForm.value.mobileNumber) {
            this.toastr.warning(this.translateService.instant("Services.PleaseFillInPhoneNumber"));
            return;
        }

        this.oneHttpClient.validate(this.searchForm.value.mobileNumber)
            .subscribe(
                {
                    next: () => {
                        // * This means that the check from Backend is successfully so we open modal to confirm the number
                        this.confirmNumberModalService.open();
                    },
                    error: (error: HttpErrorResponse) => {
                        this.toastr.warning(error.error);
                    }
                }
            );
    }

    mobileNumberConfirmed(value) {
        // * Check if confimed number is the same as the number we searched
        if (value !== this.searchForm.value.mobileNumber) {
            this.toastr.warning(this.translateService.instant("Services.NumberNotMatch"));
            return;
        }

        // * Close confirm number modal
        this.confirmNumberModalService.close();

        // * Manage screening state
        this.switchScreen(2);
    }

    async catchAllPayment() {
        if (!this.paymentForm.valid) {
            this.toastr.warning(this.translateService.instant("Services.PleaseSelectAmount"));
            return;
        }

        // * Set amount of transaction
        this.walletService.amountOfTransaction = +this.paymentForm.value.amount;

        const commission = await this.oneHttpClient
            .getCommission(+this.paymentForm.value.amount);

        this.komisionCC = commission.amount.komisionCC;

        this.modalService.open();
    }

    private resetSearchFrom() {
        this.searchForm.reset();
    }

    private resetPaymentForm() {
        this.paymentForm.patchValue({
            shouldSearchForOffers: true,
            amount: "0"
        });
    }

    processOneTransaction(creditCardMethod: boolean = false) {
        if (creditCardMethod) {
            this.oneHttpClient
                .payCC(this.searchForm.value.mobileNumber, this.paymentForm.value.amount)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (response) => {
                        if (!response.data) {
                            this.walletService.emitTransactionProgress({
                                    isSuccess: false,
                                    error: response.error.message
                                }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "one");

                        window.location = (response.data.redirect);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject: TransactionStatusEmitter = {
                            isSuccess: false,
                            error: error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        } else {
            this.oneHttpClient
                .payWallet(this.searchForm.value.mobileNumber, this.paymentForm.value.amount)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: () => {
                        const emitterObject = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emitterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emitterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };
                        this.walletService.emitTransactionProgress(emitterObject);
                    }
                });
        }
    }

    // * Helper method to help maintaining screens
    switchScreen(screen: number) {
        switch (screen) {
            case 1:
                this.resetSearchFrom();
                this.screenOne = true;
                this.screenTwo = false;
                this.screenThree = false;
                break;
            case 2:
                this.resetPaymentForm();
                this.screenOne = false;
                this.screenTwo = true;
                this.screenThree = false;
                break;
            case 3:
                this.screenOne = false;
                this.screenTwo = false;
                this.screenThree = true;
                break;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.ccSubscription.unsubscribe();
        this.finishTransactionSubscription.unsubscribe();
    }
}
